module.exports = __webpack_public_path__ + "static/media/PhoneIcon.7ff980c3.svg";